import axios from "axios";
import { ToastNotifyError } from "../components/CommonComponents/Toast/ToastNotify";
import { fetchLogout } from "../store/reducers/authentication/apiThunk";

const client = ({ auth_token = "", isAuthHeader = false, deviceType = true, dispatch }) => {
  const defaultOptions = {
    headers: { "Content-Type": "application/json" },
  };

  const API = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  API.interceptors.request.use(
    (config) => {
      if (auth_token && isAuthHeader) {
        config.headers.Authorization = `${auth_token}`;
      } else if (auth_token && isAuthHeader && deviceType) {
        config.headers.device = "web";
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  API.interceptors.response.use(
    (response) => response,
    (error) => {
      const { response: { data: { message } = {}, status } = {} } = error;
      if (status === 401) {
        ToastNotifyError(message);
        if (dispatch && auth_token) dispatch(fetchLogout()); // ✅ Ensure dispatch is available
      } else if (parseInt(status / 100) === 5) {
        ToastNotifyError(message);
      }
      return Promise.reject(error);
    }
  );

  return {
    get: (url, options = {}) => API.get(url, { ...defaultOptions, ...options }),
    post: (url, data, options = {}) => API.post(url, data, { ...defaultOptions, ...options }),
    patch: (url, data, options = {}) => API.patch(url, data, { ...defaultOptions, ...options }),
    put: (url, data, options = {}) => API.put(url, data, { ...defaultOptions, ...options }),
    delete: (url, options = {}) => API.delete(url, { ...defaultOptions, ...options }),
  };
};

const getAuthorization = (getState, dispatch, ...restProps) => {
  const {
    authentication: {
      auth: { data: { data: { auth_token = "" } = {} } = {} } = {} 
    } = {},
  } = getState() 

  return client({ auth_token, dispatch, ...restProps[0] });
};

export { getAuthorization };
export default client;
